import { ParentComponent } from 'solid-js'
import { A, useLocation } from '@solidjs/router'
import { IconCard, IconCoin, IconBolt } from './Icons'
import { useBreakpoint } from './useBreakpoint'

const navItems = [
  { id: 'subs', label: 'Subscriptions', shortLabel: 'Subs', icon: IconCard, route: '/subscriptions' },
  { id: 'payments', label: 'Payment History', shortLabel: 'Payments', icon: IconCoin, route: '/payment-history' },
  { id: 'settings', label: 'Settings', shortLabel: 'Settings', icon: IconBolt, route: '/settings' },
]

export const AccountLayout: ParentComponent = (props) => {
  const location = useLocation()
  const bp = useBreakpoint()

  const isActive = (route: string) => location.pathname.startsWith(route)

  return (
    <div class="cf-acct-page">
      {/* Inner left nav */}
      <aside class="cf-acct-inner-nav">
        <div class="cf-acct-inner-nav-label">Account</div>
        {navItems.map((item) => (
          <A
            href={item.route}
            class={`cf-acct-inner-link ${isActive(item.route) ? 'active' : ''}`}
          >
            <item.icon size={18} />
            <span>{bp() === 'mobile' ? item.shortLabel : item.label}</span>
          </A>
        ))}
      </aside>

      {/* Main content */}
      <main class="cf-acct-main">{props.children}</main>
    </div>
  )
}
